<template>
    <v-card>
        <v-toolbar color="primary">
            <v-toolbar-title style="width:100%; text-align: center; color: white">
                Bloqueio
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="bloqueio" style="font-size: 1.3em; text-align: justify;">
            A empresa {{bloqueio.empresa.nome_fantasia}} foi bloqueada {{bloqueio.posto ? `pelo posto ${bloqueio.posto.nome_fantasia}` : `pela rede ${bloqueio.rede.nome}`}}
            pelo motido de {{bloqueio.motivo}}.
        </v-card-text>
        <v-card-text>
            <v-select
                label="Ação"
                v-model="idAcao"
                :items="[
                    { text: 'Marcar como lida', id: 1 },
                    { text : 'Bloquear também', id: 2 },
                    { text : 'Ver mais tarde', id: 3 }
                ]"
                item-text="text"
                item-value="id"
                outline
            />
            <v-btn block color="primary" @click="confirmar">Confirmar</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: ['bloqueio'],
    data () {
        return {
            idAcao: 1
        }
    },
    methods: {
        marcarComoLida () {
            this.$store.dispatch('marcarComoVisto', this.bloqueio.id).then(() => {
                this.$emit('carregarNotificacoes')
                this.$emit('fechar')
            })
        },
        confirmar () {
            switch (this.idAcao) {
                case 1:
                    this.marcarComoLida()
                    break
                case 2:
                    this.$store.dispatch('ativarOuDesativarEmpresa', this.bloqueio.empresa.cnpj).then(() => {
                        this.marcarComoLida()
                    })
                    break
                case 3:
                    this.$emit('fechar')
            }
        }
    }
}
</script>
